import React from 'react';

import PropTypes from 'prop-types';

import { Container } from './styles';
import { useExtra } from '../../../../hooks/selectors';
import { DiskButton } from '../../DiskButton/DiskButton';
import BaseLayout from '../BaseLayout';
import { MainColumn } from '../MainColumn/MainColumn';
import { NavBar } from '../NavBar/NavBar';
import { StubPage } from '../StubPage';

export const CommonPage = (props) => {
    const { gaServerNotAvailable } = useExtra();
    const setNavBarAlign = () => {
        if (props.rightHeaderComponent && props.backUrl) {
            return 'space-between';
        } else if (props.backUrl || props.isBackButton) {
            return 'left';
        } else {
            return 'right';
        }
    };

    const getRenderComponent = () => {
        if (gaServerNotAvailable && props?.stateOptions?.isGA) {
            return (
                <MainColumn>
                    <StubPage />
                </MainColumn>
            );
        } else {
            return <>{props.children}</>;
        }
    };

    return (
        <BaseLayout showPromoBanner={props.showPromoBanner}>
            <Container hasBottomPanel={props.hasBottomPanel}>{getRenderComponent()}</Container>
            {(props.backUrl || props.rightHeaderComponent || props.isBackButton) && (
                <NavBar align={setNavBarAlign()}>
                    {(props.backUrl || props.isBackButton) && (
                        <DiskButton
                            type={props.isTagA ? 'tagA' : props.isBackButton ? 'button' : null}
                            to={props.backUrl}
                            href={props.backUrl}
                            onClick={props.onClickIcon}
                            iconName={props.leftCloseIcon ? 'cross' : 'arrow-back'}
                        />
                    )}
                    {props.rightHeaderComponent}
                </NavBar>
            )}
        </BaseLayout>
    );
};

CommonPage.propTypes = {
    showPromoBanner: PropTypes.bool,
    backUrl: PropTypes.string,
    leftCloseIcon: PropTypes.bool, // если нужен крестик слева
    rightHeaderComponent: PropTypes.object,
    hasBottomPanel: PropTypes.bool, // если внизу на странице есть панель с кнопкой
    onClickIcon: PropTypes.func,
    isTagA: PropTypes.bool,
    isBackButton: PropTypes.bool,
};
